import { AppyError } from '../../../../../../Appy';
import { MissingLinkError } from '../../../../../../LinkyLinky';
import { ShareableLinksResource } from '../Types';

export interface Waiting {
  kind: 'waiting';
  learningCollectionResource: ShareableLinksResource;
}

export interface Ready {
  kind: 'ready';
  learningCollectionResource: ShareableLinksResource;
}

export interface Creating {
  kind: 'creating';
  learningCollectionResource: ShareableLinksResource;
}

export interface Error {
  kind: 'error';
  error: ShareUrlError;
  learningCollectionResource: ShareableLinksResource;
}

export type ShareUrlError = AppyError | MissingLinkError;

export type State = Waiting | Ready | Creating | Error;

export const waiting = (learningCollectionResource: ShareableLinksResource): Waiting => ({
  kind: 'waiting',
  learningCollectionResource,
});

export const ready = (learningCollectionResource: ShareableLinksResource): Ready => ({
  kind: 'ready',
  learningCollectionResource,
});

export const creating = (state: Waiting | Ready): Creating => ({
  kind: 'creating',
  learningCollectionResource: state.learningCollectionResource,
});

export const error = (error: ShareUrlError, state: Waiting | Ready | Creating): Error => ({
  kind: 'error',
  learningCollectionResource: state.learningCollectionResource,
  error,
});
